import {
    STATUS_CHANGE_NOTE_ACTIONS,
    STATUS_CHANGE_NOTE_STATUSES,
} from '~/components/StatusChangeNote/constants/statusChangeNote';
import type {
    StatusChangeNoteAction,
    StatusChangeNoteState,
} from '~/components/StatusChangeNote/types/statusChangeNote';

export const initialStatusChangeNoteState: StatusChangeNoteState = {
    editedContent: null,
    status: STATUS_CHANGE_NOTE_STATUSES.CLOSED,
};

export function statusChangeNoteReducer(
    state: StatusChangeNoteState,
    action: StatusChangeNoteAction,
): StatusChangeNoteState {
    if (action.type === STATUS_CHANGE_NOTE_ACTIONS.RESET) return initialStatusChangeNoteState;

    switch (state.status) {
        case STATUS_CHANGE_NOTE_STATUSES.CLOSED:
            if (action.type !== STATUS_CHANGE_NOTE_ACTIONS.TOGGLED || !action.checked) return state;
            return state.editedContent === null
                ? { status: STATUS_CHANGE_NOTE_STATUSES.PREFILLED }
                : { content: state.editedContent, status: STATUS_CHANGE_NOTE_STATUSES.EDITED };
        case STATUS_CHANGE_NOTE_STATUSES.PREFILLED:
            switch (action.type) {
                case STATUS_CHANGE_NOTE_ACTIONS.TOGGLED:
                    return action.checked ? state : initialStatusChangeNoteState;
                case STATUS_CHANGE_NOTE_ACTIONS.CONTENT_CHANGED:
                    return { content: action.content, status: STATUS_CHANGE_NOTE_STATUSES.EDITED };
                default:
                    return state;
            }
        case STATUS_CHANGE_NOTE_STATUSES.EDITED:
            switch (action.type) {
                case STATUS_CHANGE_NOTE_ACTIONS.TOGGLED:
                    return action.checked
                        ? state
                        : { editedContent: state.content, status: STATUS_CHANGE_NOTE_STATUSES.CLOSED };
                case STATUS_CHANGE_NOTE_ACTIONS.CONTENT_CHANGED:
                    return { content: action.content, status: STATUS_CHANGE_NOTE_STATUSES.EDITED };
                default:
                    return state;
            }
        default:
            return state satisfies never;
    }
}
